

export const greeting = {
	username: 'Jisun',
	title: 'Hello I\'m Jisun Lee',
	subTitle: " 새로운 도전을 좋아합니다 🤍 ",
	role: " Frontend / Backend 🖥Developer🖥",
	resumeLink: "https://github.com/jisun22/jisun22",
	view: true
};

export const socialMediaLinks = {
	github: 'https://github.com/jisun22/jisun22',
	email: 'dlwltjs8542@naver.com',
	instagram: "https://www.instagram.com/ddonnn_2/",
};

export const skills = {
	title: "I Can Do",
	subTitle: "It's my Language skill",
	describeSkills: [
		"✔ HTML5",
		"✔ CSS3",
		"✔ MySQL",
		"✔ Servlet / JSP, jdbc",
		"✔ Spring Framework, Mybatis, Ajax",
		"✔ JQuery / Javascript",
		"✔ React : typeScript/node.js/next.js",
	],
	lists: [
		{fontAwesome: "fab fa-html5", text: "HTML5", proficiency: 80},
		{fontAwesome: "fab fa-css3-alt", text: "CSS3", proficiency: 80},
		{fontAwesome: "fab fa-css3-alt", text: "MySQL", proficiency: 40},
		{fontAwesome: "fab fa-css3-alt", text: "JSP", proficiency: 50},
		{fontAwesome: "fab fa-css3-alt", text: "Spring", proficiency: 60},
		{fontAwesome: "fab fa-js", text: "JS", proficiency: 60},
		{fontAwesome: "fab fa-react", text: "React", proficiency: 60},

	],
	view: true
};


export const projects = {
	title: "Jisun Projects ",
	subTitle: "🤍Please look at my Projects🤍",
	lists: [
		{
			title: "Project1 : Tool Library",
			desc: "팀 프로젝트 Tool Library",
			url: "https://github.com/jisun22/ToolLibrary"
		},
		{
			title: "Project2 : 게시판",
			desc: "개인 프로젝트 게시판",
			url: "https://github.com/jisun22/ToolLibrary"
		},
		{
			title: "Project3 : Vuedongsan",
			desc: "개인 프로젝트 Vuedongsan",
			url: "https://github.com/jisun22/ToolLibrary"
		},
		{
			title: "Project4 : JSGroup",
			desc: "개인 프로젝트 JSgroup",
			url: "https://github.com/jisun22/jsgroup"
		},
		{
			title: "Project5 : LeepetStore",
			desc: "개인 프로젝트 LeePetStore",
			url: "https://github.com/jisun22/LeePetStore"
		},
		{
			title: "Project6 : ReactClass",
			desc: "ReactClass",
			url: "https://github.com/jisun22/ReactClass"
		}
	],
	view: true
}

export const achievements = {
	title: "Achievements And Certifications ",
	subTitle: "subtitle for achievement",
	lists: [
		{
			img: require("./assets/sad-icon.png"),
			alt: "I'm sad..",
			title: "There is no Achievement...😥",
			desc: "I'll try harder!"
		},
		{
			img: require("./assets/sad-icon.png"),
			alt: "I'm sad..",
			title: "There is no Certification...😥",
			desc: "I'll try harder!"
		},
	],
	view: true
};


export const contactInfo = {
	title: "Contact To Me! 📞",
	subTitle: "👉 Email: dlwltjs8542@naver.com",
	introduce: "I always look forward to hearing from you ☺💛 ",
	view: true
}